import { useIntl } from 'react-intl';

import { pricingPlanMessages } from 'src/features/pricingPlan/utils/messages';
import { Badge } from 'src/registry/ui/Badge';
import { cn } from 'src/utils/shadcn';

type VersionStatusBadgeProps = {
    is_current_version?: boolean;
    validFrom?: string;
};
const VersionStatusBadge = ({ is_current_version, validFrom }: VersionStatusBadgeProps) => {
    const { formatMessage } = useIntl();
    const today = new Date();

    const validFromInFuture = !is_current_version && !!validFrom && today < new Date(validFrom);

    const versionStatusTitle = () => {
        if (is_current_version) {
            return pricingPlanMessages.currentVersion;
        }
        if (validFromInFuture) {
            return pricingPlanMessages.scheduledChanges;
        }

        return pricingPlanMessages.pastVersion;
    };

    return (
        <span className="flex">
            <Badge className="max-w-full">
                <span
                    className={cn(
                        'size-1.5 rounded-full bg-red-600',
                        is_current_version && 'bg-emerald-600',
                        validFromInFuture && 'bg-orange-500',
                    )}
                />
                <span>{formatMessage(versionStatusTitle())}</span>
            </Badge>
        </span>
    );
};

export default VersionStatusBadge;
